// src/components/mail/mailUtils.js

export function splitEmails(text) {
  if (!text) return [];
  return text
    .split(/[,;\n\r\t ]+/g)
    .map((x) => x.trim())
    .filter(Boolean);
}

export function uniq(arr) {
  const s = new Set();
  const out = [];
  for (const x of arr || []) {
    const k = String(x || "").trim().toLowerCase();
    if (!k) continue;
    if (!s.has(k)) {
      s.add(k);
      out.push(String(x).trim());
    }
  }
  return out;
}

export function isLikelyEmail(v) {
  if (!v) return false;
  // basit kontrol (tam RFC değil)
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
}

export function safeJsonParseArray(input) {
  if (!input) return [];
  if (Array.isArray(input)) return input;
  if (typeof input !== "string") return [];
  try {
    const parsed = JSON.parse(input);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
